import { ROUTER_HELPERS } from "./router";

export enum TypeValueExam {
  MOCK_TEST = "MOCK_EXAM",
  PRACTICE_TEST = "PRACTICE_TEST",
  MY_PRACTICE_TEST = "MY_PRACTICE_TEST",
}
export enum ExamType {
  ME = "Mock Exams",
  PT = "Preset Practice Tests",
  MPT = "My Practice Tests",
}
export enum LoginTab {
  KCB_LMS = "kcb_lms",
  REGISTERED = "registered",
}
export const TypeValue = {
  all: "all",
  choice: "choice",
  case_study: "case_study",
  text: "text",
};
export const Types = [
  { value: "all", title: "All" },
  // { value: "choice", title: "Single/Multiple choice" },
  { value: "choice", title: "Multiple Choice" },
  { value: "case_study", title: "Case Study" },
  { value: "text", title: "Standard" },
];

export const QuestionSchemaTabs = {
  answer: "Indicative Answer",
  marking_scheme: "Marking Scheme",
  rubric: "Rubric",
};

export const STATUS_REDIRECTS: Record<number, string> = {
  401: ROUTER_HELPERS.error(401),
  403: ROUTER_HELPERS.error(403),
  // 404: ROUTER_HELPERS.error(404),
  500: ROUTER_HELPERS.error(500),
  503: ROUTER_HELPERS.error(503),
};

export const STATUS_MESSAGES: Record<number, string> = {
  401: "Your session has expired. Please sign in again.",
  403: "You do not have permission to access this resource.",
  404: "Resource not found.",
  500: "Internal Server Error!",
  503: "Server is under maintenance. Please try again later.",
};

export const Levels = [
  {
    level: "1",
    status: "Fail",
    color: "#B42318",
    bgColor: "#FEF3F2",
  },
  {
    level: "2",
    status: "Pass",
    color: "#F79009",
    bgColor: "#FFFAEB",
  },
  {
    level: "3",
    status: "Merit",
    color: "#17B26A",
    bgColor: "#ECFDF3",
  },
  {
    level: "4",
    status: "Distinction",
    color: "#0057B8",
    bgColor: "#f0f7ff",
  },
];
